import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Alert, AlertBody, AlertDescription, AlertIcon, AlertTitle, Button, HStack, Spacer } from '@bonusly/design-system';
import { useCurrentUser } from '@bonusly/who-am-i';

import { useFeedbackActions } from '../../hooks/use-feedback-actions';
import { useEvaluation } from './context';

export const ExpiredActions: FC = () => {
	const evaluation = useEvaluation();
	const user = useCurrentUser();
	const { t } = useTranslation('feedback');
	const { deleteRequest, isDeleting, isResending, resendRequest } = useFeedbackActions(evaluation);

	if (!evaluation.isExpired() || !evaluation.receiverIs(user.id)) {
		return null;
	}

	const isLoading = isDeleting || isResending;

	return (
		<Alert status="info" size="sm" alignItems="center">
			<AlertIcon />

			<AlertBody>
				<HStack w="full">
					<AlertTitle fontSize="md">{t('pending.expired_title')}</AlertTitle>
					<AlertDescription fontSize="md">{t('pending.expired_description')}</AlertDescription>
					<Spacer />
					<Button colorScheme="secondary" isDisabled={isLoading} onClick={resendRequest} size="sm" variant="alpha">
						{t('pending.resend')}
					</Button>
					<Button colorScheme="secondary" isDisabled={isLoading} onClick={deleteRequest} size="sm" variant="alpha">
						{t('pending.delete')}
					</Button>
				</HStack>
			</AlertBody>
		</Alert>
	);
};
